import { render } from "./TeamInvite.vue?vue&type=template&id=35019ee0&scoped=true"
import script from "./TeamInvite.vue?vue&type=script&lang=js"
export * from "./TeamInvite.vue?vue&type=script&lang=js"

import "./TeamInvite.vue?vue&type=style&index=0&id=35019ee0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35019ee0"]])

export default __exports__